import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { SectionNumber } from '@components/Section-Number';
import { ComplexMaterial } from './organism/complex-material';
import { CloudRendering } from './organism/cloud-rendering';
import { CameraLighting } from './organism/camera-lighting';
import { Autosaving } from './organism/autosaving';
import { ModelsLibrary } from './organism/models-library';
import { Estimate } from './organism/estimate';
import { OwnLibrary } from './organism/own-library';
import { Folders } from './organism/folders';
import { OsSupport } from './organism/os-support';
import { Tokens } from './organism/tokens';
import { Points } from '@styles';

export const Opportunities = ({ locale }) => {
  const translations = useTranslations();

  return (
    <View id="opportunities">
      <Content>
        <WrapperTop>
          <SectionNumber number={''} text={translations.t('site.home.opportunities.name')} />
          <Title>{translations.t('site.home.opportunities.title')}</Title>
          <Description>{translations.t('site.home.opportunities.description')}</Description>
        </WrapperTop>
        <CardsWrapper>
          <ComplexMaterial />
          <CloudRendering />
          <CameraLighting />
          <Tokens />
          <Autosaving />
          <ModelsLibrary />
          <Estimate />
          <OwnLibrary locale={locale} />
          <Folders />
          <OsSupport />
        </CardsWrapper>
      </Content>
    </View>
  );
};

const View = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 18px;
  background-color: #f5f5f5;

  media ${Points.tablet_landscape} {
    padding: 40px 0;
  }

  @media ${Points.laptop_wide} {
    padding: 90px 80px;
  }
`;

const Content = styled.div``;

const WrapperTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 430px;
  margin: 0 auto 20px;

  @media ${Points.tablet_landscape} {
    width: 430px;
    max-width: auto;
    text-align: center;
    margin: 0 auto 40px;
  }

  @media ${Points.laptop_wide} {
    width: 670px;
  }

  @media ${Points.fullhd} {
    margin-bottom: 20px;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;

  @media ${Points.tablet_portrait} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @media ${Points.tablet_landscape} {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    width: 100%;
    max-width: 1024px;
    padding: 0 28px;

    & > :nth-child(4n + 1) {
      grid-column: span 2;
    }

    & > :nth-child(4n + 2) {
      grid-column: span 3;
    }

    & > :nth-child(4n + 3) {
      grid-column: span 3;
    }

    & > :nth-child(4n + 4) {
      grid-column: span 2;
    }
  }

  @media ${Points.laptop_wide} {
    display: grid;
    grid-template-columns: 235px 235px 220px 235px 235px;
    gap: 30px;
    width: 100%;
    max-width: 1280px;
    padding: 0;
  }
`;

const Title = styled.h2`
  margin-top: -5px;
  margin-bottom: 15px;
  font-weight: 400;
  font-size: 26px;
  line-height: 1;
  letter-spacing: 0%;
  font-variant-numeric-fraction: stacked-fractions;

  @media ${Points.tablet_landscape} {
    font-size: 34px;
  }

  @media ${Points.laptop_wide} {
    width: 670px;
    font-size: 54px;
  }
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.1;
  letter-spacing: 1%;

  @media ${Points.laptop_wide} {
    width: 470px;
    font-size: 14px;
  }
`;
